import type { Editor, NodeEntry } from 'slate';

import type {
  DynamicBlockElement,
  RenderModelContentBlock,
  RenderModelDynamicBlock,
} from '../internal';
import { getOrCreateCachedRMBlockChild, Queries } from '../internal';

export function buildRenderModelDynamicBlock(
  editor: Editor,
  options: {
    containerWidthPx: number;
    dynamicBlockEntry: NodeEntry<DynamicBlockElement>;
    isInHeaderFooter: boolean;
    pageNum: number;
  }
): RenderModelDynamicBlock {
  const { containerWidthPx, dynamicBlockEntry, isInHeaderFooter, pageNum } = options;
  const [dynamicBlock, dynamicBlockPath] = dynamicBlockEntry;
  const isCollapsed = Queries.getIsCollapsedDynamicBlock(editor, { dynamicBlockEntry });
  const cachedKey = Queries.findKey(dynamicBlock);
  const { aggregatedHeight, children } = dynamicBlock.children.reduce<{
    aggregatedHeight: number;
    children: RenderModelContentBlock[];
  }>(
    ({ aggregatedHeight, children }, child, index) => {
      const cachedChild = getOrCreateCachedRMBlockChild(editor, {
        containerWidthPx,
        isInHeaderFooter,
        nodeEntry: [child, [...dynamicBlockPath, index]],
        pageNum,
      });
      children.push(cachedChild);

      return { aggregatedHeight: aggregatedHeight + cachedChild.heightPx, children };
    },
    { aggregatedHeight: 0, children: [] }
  );

  return {
    ...dynamicBlock,
    children,
    heightPx: !isCollapsed ? aggregatedHeight : 0,
    key: cachedKey.id,
    relativePath: Queries.getPathRelativeToParent(dynamicBlockPath),
    widthPx: containerWidthPx,
  };
}
